// ¿Qué onboarding le debe esta cuenta? (ADR-2026-10-31-onboarding-corto-para-la-prueba)
//
// Desde ese ADR hay dos, en dos rutas:
//   · el cuestionario corto (`/configuracion-cuenta`: nombre → rubro → producto), el alta de la
//     prueba gratis. Lo debe la empresa con el rubro centinela, como siempre
//     (`onboardingPendiente`).
//   · el onboarding de marca (`/configurar-marca`), largo, que se hace al empezar a PAGAR. Lo
//     debe el dueño de una empresa paga con `debe_onboarding_marca` (la prende el front nuevo al
//     crear la empresa y la apaga el final de ese onboarding), o con el rubro centinela: el alta
//     por link, que paga antes de que se le pregunte nada.
//
// Una sola regla para las cuatro piezas que la aplican (el rebote de `App`, el flag en memoria,
// la lectura de la base y el corte del primer paso): tenerla repetida es cómo se desincronizan.
// Sin fila no se afirma nada: una lectura fallida nunca manda a nadie a ningún lado.

import { ONBOARDING_V2 } from '../components/onboarding/onboardingV2Routes';
import { esDuenoDeLaCuenta } from './duenoDeLaCuenta';
import { onboardingPendiente } from './onboardingPendiente';
import { isPaidPlan } from './planCapabilities';

export type OnboardingDebido = 'cuestionario' | 'marca' | null;

/** Lo que hace falta leer de `company_profiles` para decidir. */
export interface FilaDeOnboarding {
  plan?: string | null;
  rubro?: string | null;
  debe_onboarding_marca?: boolean | null;
  owner_user_id?: string | null;
}

export const COLUMNAS_DE_ONBOARDING = 'plan, rubro, debe_onboarding_marca, owner_user_id';

/**
 * `recienPago`: la persona acaba de pagar en esta pestaña. El plan lo escribe sólo el webhook y
 * puede seguir diciendo `gratis` un rato, así que ahí el plan no se mira: alcanza con deberla.
 */
export function onboardingQueSeDebe(
  fila: FilaDeOnboarding | null | undefined,
  userId: string | null | undefined,
  opts?: { recienPago?: boolean },
): OnboardingDebido {
  if (!fila) return null;
  const sinRubro = onboardingPendiente(fila.rubro);
  // Un invitado no pagó nada: no debe la marca. El centinela sigue mandándolo al cuestionario,
  // como antes de este cambio (en la práctica un invitado nunca lo tiene).
  if (esDuenoDeLaCuenta(fila, userId)) {
    const pago = isPaidPlan(fila.plan) || opts?.recienPago === true;
    if (pago && (fila.debe_onboarding_marca === true || sinRubro)) return 'marca';
  }
  return sinRubro ? 'cuestionario' : null;
}

export function rutaDelOnboarding(debido: Exclude<OnboardingDebido, null>): string {
  return debido === 'marca' ? ONBOARDING_V2.marcaSetup : ONBOARDING_V2.setup;
}
